import { API_CONFIG } from '@/config/api';
import { httpClient } from '@/utils/httpClient';

export type TransfersShippingType = 'transfer' | 'shipment';

export interface TransfersShippingCompleteParams {
  assetIds: string[];
}

export interface TransfersShippingCompleteResult {
  success: boolean;
  processedAt: string;
  totalQuantity: number;
  assetIds: string[];
  transactionId: string;
  logId: string;
}

export class TransfersShippingService {
  async completeTransfer(
    params: TransfersShippingCompleteParams,
  ): Promise<TransfersShippingCompleteResult> {
    return httpClient.post(`${API_CONFIG.ACTIONS_API_BASE_PATH}/transfers-shipping/transfer`, {
      assetIds: params.assetIds,
    });
  }

  async completeShipment(
    params: TransfersShippingCompleteParams,
  ): Promise<TransfersShippingCompleteResult> {
    return httpClient.post(`${API_CONFIG.ACTIONS_API_BASE_PATH}/transfers-shipping/shipment`, {
      assetIds: params.assetIds,
    });
  }
}

export const transfersShippingService = new TransfersShippingService();
